module.exports = __webpack_public_path__ + "8df833e8717282f4423a73fa5e174bdc.jpg";